export default __webpack_public_path__ + "static/belmont-ccf2388112190cdae890045c2a304f1d.png";